    import { Box,Button,Flex,Select,InputGroup,
      InputLeftElement,Input, Text, 
      TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem, Checkbox,
      FormControl,
      FormLabel,
      InputRightElement,
      Stack} from "@chakra-ui/react";
    import { TopDisplay } from "../../../../components";
    import { IoMdAdd as AddIcon } from "react-icons/io";
    import { LuSearch as SearchIcon } from "react-icons/lu";
    import { useState,useEffect, useRef } from "react";
    import { useMutation, useQuery, useQueryClient } from 'react-query';
    import styled from "@emotion/styled";
    import { atom, useAtom } from 'jotai';
    import apiCall from '../../../../utils/apiCall';
    import {ExamPeriod, TopLink} from '../';
    import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
    import { Formik,Form,Field, ErrorMessage } from "formik";
    import {TablePopUp} from '../../../../components';
    import * as Yup from 'yup';
    import { format, setDate } from "date-fns";
    import { DateFilter} from '../../../../components';
    import { Loader } from "../../../../customs";
    import { TbReload as ReloadIcon } from "react-icons/tb";
    import ReactPaginate from 'react-paginate';
    import { IoReloadCircleOutline as ResetIcon} from "react-icons/io5";
    import ReactSelect from "../../../../components/Select";
    import appStore, { activePeriod } from "../../../../store";

    // const allExamTimeTable = [
    //   {
    //     Id:Math.floor(Math.random() * 10000)+1,
    //     ExamId:'12345',
    //     SubjectName:'Internet of things',
    //     Level:'2',
    //     CutOffMark: '50',
    //     Amount:'300,000'
    //   },
    //   {
    //     Id:Math.floor(Math.random() * 10000)+1,
    //     ExamId:'12345',
    //     SubjectName:'Internet of things',
    //     Level:'2',
    //     CutOffMark: '50',
    //     Amount:'300,000'
    //   },
    //   {
    //     Id:Math.floor(Math.random() * 10000)+1,
    //     ExamId:'12345',
    //     SubjectName:'Internet of things',
    //     Level:'2',
    //     CutOffMark: '50',
    //     Amount:'300,000'
    //   } ,
    //   {
    //     Id:Math.floor(Math.random() * 10000)+1,
    //     ExamId:'12345',
    //     SubjectName:'Internet of things',
    //     Level:'2',
    //     CutOffMark: '50',
    //     Amount:'300,000'
    //   },
    //   {
    //     Id:Math.floor(Math.random() * 10000)+1,
    //     ExamId:'12345',
    //     SubjectName:'Internet of things',
    //     Level:'2',
    //     CutOffMark: '50',
    //     Amount:'300,000'
    //   }  
    // ]

    const HeadStyle={
      borderBottom:"1px solid var(--dark-green-color)",
      padding:'15px 5px',
    }
    const DataStyle = {
      padding:'5px 5px',
    }


    const ROWSTYLE = styled.tr`
      & > td:last-of-type > *{
        display:none;
      }
      :hover > td{
        background-color:var(--table-highlight);
        &:last-of-type > *{
          display:block;
        }
      } 
      &.active > td:last-of-type > *{
        display:block !important;
      }  
    `

    const ExamTimeTableAtom = atom<number | null>(null);


    export default function ExamTimeTable() {
      const [hide, set_hide] = useState<boolean>(true);
      const [, set_modal] = useAtom(modalAtom);
      const [, set_open] = useAtom(openAtom);
      const [active] = useAtom<number | string | null>(ExamTimeTableAtom);
      // const [selected_examperiod,set_selected_examperiod] = useState<any>('');
      const [filter_data,set_filter_data] = useState<any>([]);
      const [selected_level,set_selected_level] = useState(null);

    
      const {data:allExamSubject} = useQuery(['exam-subject'],{
        queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
        select(data){
          return data.data.Data;
        },
      })


      const { data: allExamPeriod } = useQuery(['exam-period'], {
        queryFn: async () => await apiCall().get(`exam/setup/examPeriod`),
        select(data) {
          return data.data.Data;
        },
      });

      const { data: allLevel } = useQuery(['exam-level'], {
        queryFn: async () => await apiCall().get(`/SetUp/GetAllExemption`),
        select(data) {
          return data.data.Data;
        }
      });

      const { data: allExamTimeTable,isLoading } = useQuery(['exam-time-table'], {
        queryFn: async () => await apiCall().get(`/exam/setup/examTimeTable`),
        select(data) {
          return data.data.Data;
        }
      });

      const [search,set_search] = useState('');
      

      const handleSearch = (e:any)=>{
        let val = e.target.value;
        console.log(val,'input value')
        set_search(val);
        if(val){
          let new_data = filter_data?.filter((eData:any) => Object.values(eData).map((eData:any)=> typeof eData === 'object' && eData !== null && !Array.isArray(eData)?JSON.stringify(eData):eData).join().toLowerCase().includes(val.toLowerCase()) );
          if(new_data.length > 0)set_filter_data(new_data)
          else set_filter_data(allExamTimeTable)
        }
        else set_filter_data(allExamTimeTable)
      }

      const handleDateFilter = (obj:any) =>{
        const {start,end} = obj; 
        console.log(obj,'start end');
        const s_date:number = new Date(start.concat("T00:00:00") || null)?.getTime();
        const e_date:number = new Date(end.concat("T00:00:00") || null)?.getTime();
        console.log(s_date,e_date,'date in seconds')
        const tempData:any = allExamTimeTable;
        let f_data = tempData.filter((eData:any)=>{
          let e_date_time:number = new Date(eData?.ExamDateTime?.split('.')[0] || null)?.getTime();
          console.log(e_date_time,'time in seconds')
          return e_date_time >= s_date && e_date_time <= e_date;
        })
        //console.log(f_data,'date filtered data')
        if(f_data.length > 0)set_filter_data(f_data);
        else set_filter_data(allExamTimeTable);
      }

      // useEffect(()=>{
      //   set_filter_data(allExamTimeTable)
      // },[allExamTimeTable])

      // const [filter_data,set_filter_data] = useState<any>(allExamTimeTable);
      const itemsPerPage = 10;
      const [itemOffset, setItemOffset] = useState(0);
      const endOffset = itemOffset + itemsPerPage;
      console.log(`Loading items from ${itemOffset} to ${endOffset}`);
      const currentItems = filter_data?.slice(itemOffset, endOffset);
      const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

      const handlePageClick = (event:any) => {
        const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
        console.log(
          `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
      };

      const handleAddTimeTable = () =>{
        set_modal({
          header:'Exam Time Table',
          content:<AddType />
        })
        set_open(true);
      }

      const handleSelected = (e: any) => {
        let val = e.target.value;
        console.log(val, 'level');
      
        if (val && allExamTimeTable) {
          set_filter_data(allExamTimeTable.filter((eSubject: any) => eSubject.LevelId == val));
          
        } else {
          set_filter_data(allExamTimeTable);
        }
      
      }
      useEffect(()=>{
        set_filter_data(allExamTimeTable)
        },  [allExamTimeTable])
      
      // const handleFilter = (e: any, type: string) => {
      //   const value = type === 'level' ? Number(e || 0) : e;
      
      //   if (type === 'level') {
      //     if (value || !isNaN(value)) {
      //       let data = allExamTimeTable?.filter((eData: any) => {
      //         return eData.Level?.Id == value;
      //       });
      
      //       if (selected_examperiod) {
      //         data = data?.filter((eData: any) => eData.ExamPeriod == selected_examperiod);
      //       }
      
      //       set_filter_data(data && data.length > 0 ? data : allExamTimeTable);
      //       set_selected_level(value);
      //     }
      //   } else if (type === 'period') {
      //     if (value) {
      //       set_selected_examperiod(value); 
      //       let check: any = allExamTimeTable.filter((e: any) => e.ExamPeriod == value);
      //       set_filter_data(check && check?.length > 0 ? check : allExamTimeTable);
      //     }
      //   } else {
          
      //     let filteredData = allExamTimeTable;
      
      //     if (selected_examperiod) {
      //       filteredData = filteredData.filter(
      //         (e: any) => e.ExamPeriod == selected_examperiod
      //       );
      //     }
      
      //     set_filter_data(filteredData);
      //   }
      // };

      // const handleChangePeriod = (value: any) => {
      //   if (value) {
      //     set_selected_examperiod(value?.Id); // Store selected period
      //     let check: any = allExamTimeTable.filter((e: any) => e.ExamPeriod == value.ExamName);
      
      //     // If level is also selected, filter by level
      //     if (selected_level) {
      //       check = check?.filter((e: any) => e.Level?.Id == selected_level);
      //     }
      
      //     set_filter_data(check && check.length > 0 ? check : allExamTimeTable);
      //   }
      // };
      // useEffect(() => {
      //   filterData();
      // }, [selected_level, selected_examperiod, allExamTimeTable]);

      return (
        <>
        {isLoading?<Loader />:
        <Box>
          <TopLink />
          <TopDisplay label="Exam Timetable" button_array={[
              <Button onClick={handleAddTimeTable} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Add Timetable</Button>
            ]} />
            <Flex  gap="20px" wrap="wrap" mt="20px">
              <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
                <InputLeftElement pointerEvents='none'>
                  <SearchIcon color='gray.300' />
                </InputLeftElement>
                <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
                <span style={{position:'absolute',zIndex:'1',
                right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
              </InputGroup>
              {/* <Select placeholder='Exam Period' width="140px" bg="var(--white-color)" 
                borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_examperiod(e.target.value)}
                    name="ExamPeriodId"
                  >
                  {allExamPeriod && allExamPeriod.length > 0 ?
                      allExamPeriod.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.ExamName}</option>)
                    :''}
                  </Select> */}
                  <Select placeholder="Level" width="200px" bg="var(--white-color)" 
                borderColor="var(dark-green-color)" onChange={handleSelected}>
                  {allLevel && allLevel.length > 0 ? 
                  allLevel.map((eLevel:any) => <option key={eLevel.Id} value={eLevel.Id}>
                    {eLevel.Name}
                  </option>):''}
              </Select>
              <DateFilter onChange = {handleDateFilter}/>
              <Button onClick={()=>{set_filter_data(allExamTimeTable);set_search('')}} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<ResetIcon/>}>Reset Filter</Button>
            
            </Flex>
            <Flex mt="25px" flexDir="column" gap="10px">
              <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
            </Flex>
        {  filter_data && filter_data.length > 0 ?  <TableContainer mt="20px">
              <Table size='sm'>
              <Thead>
                <Tr>
                  <Th sx={HeadStyle}>Subject</Th>
                  <Th sx={HeadStyle}>Exam Diet</Th>
                  <Th sx={HeadStyle}>Level</Th>
                  <Th sx={HeadStyle}>Exam Date</Th>
                  <Th sx={HeadStyle}>Duration</Th>
                  <Th sx={HeadStyle} w="50px"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentItems.map((eExamTimeTable: any) => (
                  <ROWSTYLE key={eExamTimeTable.Id} className={eExamTimeTable.Id === active ? 'active' : ''}>
                    <Td sx={DataStyle}>
                      {allExamSubject && allExamSubject.find((eSub: any) => eSub.Id == eExamTimeTable.ExamSubjectId)?.Name || ''}
                    </Td>
                    <Td sx={DataStyle}>
                      {allExamPeriod && allExamPeriod.find((ePeriod: any) => ePeriod.Id == eExamTimeTable.ExamPeriodId)?.ExamName || ''}
                    </Td>
                    <Td sx={DataStyle}>
                      {eExamTimeTable.Level ? eExamTimeTable.Level.ExemptionName : ''}
                    </Td>
                    <Td sx={DataStyle}>
                        {format(new Date(eExamTimeTable.ExamDateTime), "dd/MM/yyyy")}
                        <br />
                        {format(new Date(eExamTimeTable.ExamDateTime), "hh:mm a")}
                      </Td>
                    <Td sx={DataStyle}>
                      {eExamTimeTable.Duration}Hrs
                    </Td>
                    <Td sx={DataStyle} w="50px" h="50px">
                      <TempPopUp index={eExamTimeTable.Id} data={eExamTimeTable} />
                    </Td>
                  </ROWSTYLE>
                ))}
              </Tbody>
              </Table>
            </TableContainer>
            :'No Exam TimeTable'  
          }
          <StylePaginateBox>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
            />

          </StylePaginateBox>

        </Box>
        }
        </>
        
      )
    }
    const StylePaginateBox = styled.div`
      width:100%;
      & > ul{
        list-style-type: none;
        text-align:center;
        padding:0;
        margin:0;
        margin-top:10px;
      } 
      & > ul > li{
        display: inline;
        margin:0 5px;
        padding:2px 5px;
        border-radius: 3px;
        background-color: transparent;
        color:var(--dark-green-color);
      }
      & > ul > li.selected{
        background-color: var(--highlight-paginate-background);
        color:var(--highlight-paginate-color);
      }
      & > ul > li:first-of-type,
      & > ul > li:last-of-type{
        font-weight: bold;
      }
    `

    const AddSchema = Yup.object({
      ExamSubjectId:Yup.number().required(),
      ExamPeriodId:Yup.number().required(),
      ExamDateTime:Yup.date().required(),
      IsFlexible:Yup.bool(),
      LevelId:Yup.number().required(),
      Duration:Yup.number().required('Duration is required').min(1, 'Duration must be greater than 0'),
    });

    const Label = styled.label``;  
    const monthOfYear = [
      'January','February','March','April','May',
      'June','July','August','September','October',
      'November','December'
    ]
    

    const AddType = (props: any) => {
      const queryClient = useQueryClient();
      const [, set_open] = useAtom(openAtom);
      const [, set_Nopen] = useAtom(openNAtom);
      const [, set_notification] = useAtom(notificationAtom);
      const [selectedLevel, set_selectedLevel] = useState<any>('');
      const [all_subjects, set_all_subjects] = useState<any>([]);
      const formRef = useRef<any>(null);

      // Fetch data for exam periods, subjects, and levels
      const { data: allExamPeriod } = useQuery(['exam-period'], {
        queryFn: async () => await apiCall().get(`exam/setup/examPeriod`),
        select(data) {
          return data.data.Data;
        },
      });

      const { data: allExamSubject } = useQuery(['exam-subject'], {
        queryFn: async () => await apiCall().get(`exam/setup/examSubject`),
        select(data) {
          return data.data.Data;
        },
      });

      const { data: allLevel } = useQuery(['exam-level'], {
        queryFn: async () => await apiCall().get(`/SetUp/GetAllExemption`),
        select(data) {
          return data.data.Data;
        },
      });

      // Sync `ExamPeriodId` with Formik on component load if in edit mode
      useEffect(() => {
        if (props.ExamPeriodId && allExamPeriod) {
          const initialPeriod = allExamPeriod.find((period: any) => period.Id === props.ExamPeriodId);
          if (initialPeriod) {
            formRef.current?.setFieldValue("ExamPeriodId", initialPeriod.Id); // Set Formik value on load
          }
        }
      }, [props.ExamPeriodId, allExamPeriod]);

      const handleSelectSubjectId = (e: any) => {
        const val = e.target.value;
        if (val) {
          const Level = allLevel.find((eLevel: any) => eLevel.Id == val);
          set_selectedLevel(Level);
          if (formRef.current) {
            formRef.current.setFieldValue("LevelId", Level.Id);
          }
          const subs = allExamSubject.filter((eLevel: any) => eLevel?.Level.Id == val);
          if (subs && subs.length > 0) {
            set_all_subjects(subs);
          }
        }
      };

      const { mutate: addUpdate, isLoading } = useMutation({
        mutationKey: ['new-exam-time-table'],
        mutationFn: async (data: any) => {
          return props && props.Id
            ? await apiCall().put(`/exam/setup/examTimeTable/${props.Id}`, data)
            : await apiCall().post(`/exam/setup/examTimeTable`, data);
        },
        onSuccess: (data: any) => {
          const message = props && props.Id
            ? 'Timetable updated successfully'
            : 'Timetable added successfully';

          set_notification({
            type: 'success',
            message: data?.Message || message,
          });
          set_Nopen(true);
          queryClient.invalidateQueries({
            queryKey: ['exam-time-table'],
          });
        },
        onError: (error: any) => {
          set_notification({
            type: 'error',
            message: error?.response?.data?.Message || 'An error occurred',
          });
          set_Nopen(true);
        },
        onSettled: () => {
          set_open(false);
        },
      });

      return (
        <Formik
    innerRef={formRef}
    initialValues={{
      ExamSubjectId: props.ExamSubjectId || '',
      ExamPeriodId: props.ExamPeriodId || '',
      ExamDateTime: props.ExamDateTime || '',
      IsFlexible: props.IsFlexible ? true : false,
      Duration: props.Duration || '',
      LevelId: props.LevelId || '',
    }}
    validationSchema={AddSchema}
    onSubmit={(values: any) => {
      const data: any = {
        ExamSubjectId: values.ExamSubjectId,
        ExamPeriodId: values.ExamPeriodId,
        IsFlexible: values.IsFlexible,
        ExamDateTime: values.ExamDateTime,
        LevelId: values.LevelId,
        Duration: values.Duration,
      };

      addUpdate(data);
    }}
  >
    {(formik: any) => {
      const { errors, values, touched, setFieldValue } = formik;

      // Filter subjects by selected level
      const filteredSubjects =
        values.LevelId && allExamSubject
          ? allExamSubject.filter((subject: any) => subject.LevelId === values.LevelId)
          : [];

      return (
        <Form>
          <Flex flexDir={"column"} align={"center"} borderColor="black" gap="20px">
          <Field
                as={Select}
                placeholder="Exam Period"
                bg="var(--white-color)"
                borderColor="green"
                name="ExamPeriodId"
                onChange={(e: any) => {
                  const selectedPeriod = allExamPeriod.find(
                    (period: any) => period.Id === Number(e.target.value)
                  );
                  if (selectedPeriod) {
                    setFieldValue("ExamPeriodId", e.target.value); // Update selected ExamPeriodId
                    setFieldValue("ExamStartDate", selectedPeriod.ExamStartDate); // Update ExamStartDate
                    setFieldValue("ExamEndDate", selectedPeriod.ExamEndDate); // Update ExamEndDate
                  }
                }}
              >
                {allExamPeriod && allExamPeriod.length > 0
                  ? allExamPeriod.map((eType: any) => (
                      <option key={eType.Id} value={eType.Id}>
                        {eType.ExamName}
                      </option>
                    ))
                  : ""}
              </Field>
              <Field name="ExamStartDate">
                {({ field }: any) => (
                  <Input
                    {...field}
                    value={field.value ? format(new Date(field.value), "dd/MM/yyyy hh:mm a") : ""}
                    readOnly
                    placeholder="Exam Start Date For selected Period"
                    bg="gray.100"
                    borderColor="green"
                  />
                )}
              </Field>

              <Field name="ExamEndDate">
                {({ field }: any) => (
                  <Input
                    {...field}
                    value={field.value ? format(new Date(field.value), "dd/MM/yyyy hh:mm a") : ""}
                    readOnly
                    placeholder="Exam End Date For selected Period"
                    bg="gray.100"
                    borderColor="green"
                  />
                )}
              </Field>


            {/* <Field
              as={Select}
              placeholder="Exam Period"
              bg="var(--white-color)"
              borderColor="green"
              name="ExamPeriodId"
              onChange={(e: any) => setFieldValue("ExamPeriodId", e.target.value)} // Set directly with Formik
            >
              {allExamPeriod && allExamPeriod.length > 0
                ? allExamPeriod.map((eType: any) => (
                    <option key={eType.Id} value={eType.Id}>
                      {eType.ExamName}
                    </option>
                  ))
                : ''}
            </Field> */}

            <Field
              as={Select}
              name="LevelId"
              borderColor="green"
              placeholder="Select Level"
              onChange={(e: any) => {
                setFieldValue("LevelId", e.target.value);
                setFieldValue("ExamSubjectId", ''); // Reset ExamSubjectId when level changes
              }}
            >
              {allLevel && allLevel.length > 0
                ? allLevel.map((level: any) => (
                    <option key={level.Id} value={level.Id}>
                      {level.Name}
                    </option>
                  ))
                : ''}
            </Field>

            {/* Subjects */}
            <Field as={Select} name="ExamSubjectId" borderColor="green" placeholder="Select Subject">
                {values.LevelId && allExamSubject.length > 0 ? (
                  allExamSubject
                    .filter((subject: any) => subject.LevelId == Number(values.LevelId))
                    .map((subject: any) => (
                      <option key={subject.Id} value={subject.Id}>
                        {subject.Name}
                      </option>
                    ))
                ) : (
                  <option value="">No subjects available for this level</option>
                )}
              </Field>

            {/* Exam DateTime */}
            <Input
              as={Field}
              placeholder="Select Date and Time"
              name="ExamDateTime"
              type="datetime-local"
            />
            <Box color="var(--red-color)" fontSize="12px">
              {errors && errors.ExamDateTime}
            </Box>

            {/* Duration */}
            <Field name="Duration">
              {({ field }: any) => (
                <FormControl
                  isInvalid={errors.Duration && touched.Duration}
                  isRequired
                >
                  <FormLabel>Duration</FormLabel>
                  <Flex align="center">
                    <Input
                      {...field}
                      placeholder="Enter Hour duration"
                      bg="var(--white-color)"
                      borderColor="green"
                      type="number"
                      width="89%"
                      mr={1}
                      min="1" // Prevent entering values less than 1
                    />
                    <Box as="span" color="black.500" fontSize="sm">
                      Hour(s)
                    </Box>
                  </Flex>
                  <ErrorMessage name="Duration" component={Text} />
                </FormControl>
              )}
            </Field>

            {/* Submit Button */}
            <Button
              disabled={isLoading}
              bg="var(--dark-green-color)"
              color="var(--white-color)"
              type="submit"
            >
              {isLoading ? "Loading" : 'Submit'}
            </Button>
          </Flex>
        </Form>
      );
    }}
  </Formik>
      );
    };



    const SelectWrapper = styled.div`
      width:100%;
      & > div{
        width:100%;
      }
    `

    const TempPopUp = (props:any) =>{
      const index = props.index;
      const data = props.data;
      // console.log(data,'data')
      const [active,set_active] = useAtom(ExamTimeTableAtom);
      const [,set_open] = useAtom(openAtom);
      const [,set_modal] = useAtom(modalAtom);
      const [,set_Nopen] = useAtom(openNAtom);
      const [,set_notification]= useAtom(notificationAtom);
      const queryClient = useQueryClient();
      const {mutate:deleteExamTimeTable,isLoading} = useMutation({
        mutationKey:['delete-exam-time-table'],
        mutationFn:async () => await apiCall().get(`/exam/setup/ExamTimeTable/${data?.Id}/delete`),
        onSuccess(data:any) {
          queryClient.invalidateQueries({queryKey:["exam-time-table"]})
          set_notification({
            type:'success',
            message:data?.data?.Message || 'Deleted Successfully'
          })
          set_Nopen(true);
        },
        onSettled(){
          set_open(false);
        }
      })

      const handleClick = () =>{
        if(index === active){
          set_active(null);
          return;
        }
        else{
          set_active(index);
        }
      }
      const handleView= () =>{
        set_modal({
          header:'View Exam Time Table SetUp',
          content:<Grid>
            {/* <GridItem justify="space-between" p="10px 0" as={Flex}>
              <span>Exam Id</span>
              <span>{data?.Id}</span>
            </GridItem > */}
          <Stack direction="row" spacing={4} align="center">
          <Text fontWeight="bold">Subject:</Text>
          <Text>{data?.ExamSubject.Name}</Text>
        </Stack>
            <GridItem as={Flex} justify="space-between" p="10px 0" >
              <Text fontWeight="bold">ExamPeriod:</Text>
              <span>{data?.ExamPeriod.ExamName}</span>
            </GridItem>
            <GridItem as={Flex} justify="space-between" p="5px 0">
              <Text fontWeight="bold">Level:</Text>
              <span> {data?.Level.ExemptionName}</span>
            </GridItem>
            <GridItem as={Flex} justify="space-between" p="5px 0">
              <Text fontWeight="bold">Exam Date:</Text>
              <span> {format(new Date(data?.ExamDateTime), "dd/MM/yyyy hh:mm a")}</span>
            </GridItem>
            <GridItem as={Flex} justify="space-between" p="5px 0">
              <Text fontWeight="bold">Duration:</Text>
              <span>{data?.Duration}</span>
            </GridItem>
          </Grid>
          
        })
        set_open(true);
        handleClick();
      }
      const handleEdit = () =>{
        handleClick();
        set_modal({
          header:'Edit Exam TimeTable',
          content:<AddType {...data}/>
        });
        set_open(true);
        handleClick();
        
      }
      const handleDelete = () =>{
        set_modal({
          header:'Delete Exam TimeTable',
          content:<Grid gap="20px">
            <GridItem>Are you Sure you want to delete this Exam Time Table?</GridItem>
            <GridItem as={Flex} justify="space-between" p="20px 0">
              <Button disabled={isLoading} onClick={()=>deleteExamTimeTable()} bg="var(--dark-green-color)"
                color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
              <Button disabled={isLoading} 
                variant="outline" bg="var(--white-color)"
                onClick={()=>set_open(false)}
                border="1px solid var(--dark-green-color)"
                color="var(--dark-green-color)" >Cancel</Button>
            </GridItem>
          </Grid>
        });
        set_open(true);
      }
      
      return (
        <TablePopUp click={handleClick} options={[
          {label:'View TimeTable',click:handleView},
          {label:'Edit TimeTable',click:handleEdit},
          {label:'Delete TimeTable',click:handleDelete}
        ]} />
      )
    }

